export default {
  updateOrder(state, order) {
    state.order = order
  },
  setCanCheckout(state, canCheckout) {
    state.canCheckout = canCheckout
  },
}
